import {booleanAttribute, ChangeDetectionStrategy, Component, computed, DestroyRef, input} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {GruppeMedlemListeModell, MedlemId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {AvatarKomponent} from "web-ng2/delt/komponenter/avatar/avatar";
import {TranslateModule} from "@ngx-translate/core";
import {aktiveRollePerioderSomStreng} from "felles-ng2/modell/medlemModellHjelpere";
import {filter} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

const debug = initDebugger('MøteRedigerDeltakerKontroller');

export type DeltakerSkjemaType = ReturnType<typeof MøteRedigerDeltakerKontroller.opprettSkjemarad>
export type DeltakerSkjemaVerdier = DeltakerSkjemaType['value'];
export type Deltaker = { medlem: { id: MedlemId }; skalSignere?: boolean };

@Component({
    selector: 'moete-rediger-deltaker',
    templateUrl: './møte-rediger-deltaker.html',
    styleUrls: ['./møte-rediger-deltaker.scss'],
    host: {'data-testid': 'møte-rediger-deltaker'},
    imports: [
        ReactiveFormsModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatSlideToggleModule,
        AvatarKomponent,
        TranslateModule
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteRedigerDeltakerKontroller {

    static opprettSkjemarad(medlem: GruppeMedlemListeModell, valgt: boolean, skalSignere: boolean, erStemmeberettiget: boolean, destroyRef: DestroyRef) {
        const rad = new FormGroup({
            medlem: new FormControl<GruppeMedlemListeModell>(medlem, {nonNullable: true}),
            valgt: new FormControl<boolean>(valgt, {nonNullable: true}),
            skalSignere: new FormControl<boolean>(skalSignere, {nonNullable: true}),
            erStemmeberettiget: new FormControl<boolean>(erStemmeberettiget, {nonNullable: true})
        });
        //kryss bort 'skal signere' når medlem blir valgt bort
        rad.controls.valgt.valueChanges
          .pipe(takeUntilDestroyed(destroyRef), filter(valgt => !valgt))
          .subscribe(valgt => rad.controls.skalSignere.setValue(false));

        return rad;
    }

    skjema = input.required<DeltakerSkjemaType>();
    skalSignereValgSynlig = input(true, {transform: booleanAttribute});

    aktiveMedlemsroller = computed(() => aktiveRollePerioderSomStreng(this.skjema().value.medlem!));
    erStemmeberettiget = computed(() => this.skjema().value.erStemmeberettiget ?? false);

    constructor() {
    }

    endreValgt() {
        if (this.erStemmeberettiget()) return;
        this.skjema().controls.valgt.setValue(!this.skjema().value.valgt)
    }

    // private hjelpemetoder

}
